import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await axios.post(
          `${API_BASE_URL}/logout`,
          {},
          { withCredentials: true }
        );
      } catch (err) {
        console.warn(
          'Logout API unreachable, proceeding with client-side cleanup.'
        );
      } finally {
        localStorage.removeItem('isLoggedIn');

        navigate('/login', { replace: true });
      }
    };

    performLogout();
  }, [navigate]);

  return null;
};

export default Logout;